import { toZonedTime } from 'date-fns-tz';

/**
 * Format event dates for display
 * @param {string} startDateTime - ISO 8601 datetime string in UTC
 * @param {string} endDateTime - ISO 8601 datetime string in UTC
 * @returns {string} Formatted date string
 */
export const formatDate = (startDateTime, endDateTime) => {
	if (!startDateTime) {
		return '';
	}

	const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const locale = document.querySelector('html')?.lang;

	// Convert UTC ISO 8601 strings to Date objects, then to browser's timezone
	const startDate = toZonedTime(new Date(startDateTime), timeZone);
	const endDate = endDateTime ? toZonedTime(new Date(endDateTime), timeZone) : null;

	const formatOptions = {
		weekday: 'short',
		day: 'numeric',
		month: 'long',
		year: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		timeZone,
		timeZoneName: 'short',
	};

	if (!endDate) {
		// Single date without end time
		const formatter = new Intl.DateTimeFormat(locale, formatOptions);
		return formatter.format(startDate);
	}

	// Date range
	const isSameDay = startDate.toDateString() === endDate.toDateString();

	if (isSameDay) {
		// Same day - show date once, then time range
		const timeRangeFormatter = new Intl.DateTimeFormat(locale, { ...formatOptions, hour: '2-digit', minute: '2-digit' });
		return timeRangeFormatter.formatRange(startDate, endDate);
	} else {
		// Different days - show full range
		const rangeFormatter = new Intl.DateTimeFormat(locale, formatOptions);
		return rangeFormatter.formatRange(startDate, endDate);
	}
};
